import { GET_WITH_CREDENTIALS } from '~/api';
import { ConfigApiUrl } from '~/api/urls';
import { IBackendConfig } from '~/domain/IBackendConfig';

export const getConfig = async(): Promise<IBackendConfig> => {
  const config = await GET_WITH_CREDENTIALS<IBackendConfig>(ConfigApiUrl);
  if (!config) {
    throw new Error('Could not obtain config (undefined)');
  }
  return config;
};
